export const AVAILABILITY_ZONE_NAMES = {
    MS1: 'MS1',
    DP1: 'DP1',
};

export const DISABLED_AVAILABILITY_ZONE_NAMES = ['nova'];

export const AVAILABILITY_ZONE_NAME_TO_TEXT = {
    [AVAILABILITY_ZONE_NAMES.MS1]: 'Москва-Север',
    [AVAILABILITY_ZONE_NAMES.DP1]: 'Москва-Восток',
    stage: 'Stage',
    MoscowEast: 'Москва-Восток',
};

export const AvailabilityZonesUtils = {
    getHumanReadableName(zone) {
        const name = AVAILABILITY_ZONE_NAME_TO_TEXT[zone];

        return name || zone;
    },

    getFullName(zone) {
        const name = AVAILABILITY_ZONE_NAME_TO_TEXT[zone];

        return name ? `${name} (${zone})` : zone;
    },
};
